import * as React from 'react';
import {useDispatch} from 'react-redux';

import type {FilterObject} from 'nutshell-core/types';

import {DashboardCard} from 'shells/dashboard/card/dashboard-card';
import {getIllustration} from 'shells/onboarding-checklist/helpers';
import {PromoStateOverlay} from 'shells/promo-state-overlay/promo-state-overlay';

// @ts-expect-error
import {useGetSMSDashboard} from './graphql/hooks';
import * as actions from './report/sms/sms-actions';
import {SMSChart} from './report/sms/sms-chart';

import styles from './dashboard.module.css';

const REPORT_PARAMS = {
    dateRangeType: 'period',
    facet: 'count',
    gap: 'd',
    segment: 'interactionType',
} as const;

type Props = {
    dateRange: string;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    shouldShowPromo: boolean;
};

export function SMSCard(props: Props) {
    const {activeFilters} = props;

    const {smsDashboard, isLoading} = useGetSMSDashboard({timespan: props.dateRange});
    const dispatch = useDispatch();

    const stats = smsDashboard ? smsDashboard.stats : [];

    React.useEffect(() => {
        dispatch(
            actions.requestReportData({
                reportParams: REPORT_PARAMS,
                filters: activeFilters,
            })
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeFilters]);

    return (
        <DashboardCard
            title='Text messaging'
            subtitle='Communicate with your audience through mobile'
            isLoading={isLoading}
            mainContent={{
                statsProps: {stats},
                content: (
                    <div className={styles.chart}>
                        <SMSChart
                            activeFilters={props.activeFilters}
                            onParamChange={props.onParamChange}
                            reportParams={REPORT_PARAMS}
                            height={346}
                            containerHeight={346}
                        />
                    </div>
                ),
            }}
            promoStateOverlay={
                props.shouldShowPromo && (
                    <PromoStateOverlay
                        promoStateProps={{
                            isHorizontal: true,
                            imageComponent: getIllustration('setupSMS'),
                            title: 'Configure your SMS',
                            subtitle:
                                'Enroll your company in just a few simple steps to connect with your audience through mobile.',
                            primaryCta: {
                                text: 'Learn more',
                                url: 'https://support.nutshell.com/en/articles/9674420-nutshell-sms-how-to-send-and-manage-texts',
                                isExternalLink: true,
                            },
                            secondaryCta: {
                                text: 'Set up SMS',
                                url: '/inbox/settings/sms',
                            },
                            blueImageBackground: true,
                        }}
                    />
                )
            }
        />
    );
}
